import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import satimNum from "assets/img/payment/satimnum.png";
import { useNavigate } from "react-router-dom";
import { useMessage } from "states/messageContext";


const MessageModal = () => {
    const { currentMessage, isVisible, hideMessage } = useMessage();
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (!currentMessage || !isVisible) return null;

    const getHeaderStyles = (type) => {
        switch (type) {
            case "error":
                return {
                    textColor: "text-danger",
                    borderColor: "border-b-2 border-red-600",
                };
            case "success":
                return {
                    textColor: "text-success",
                    borderColor: "border-b-2 border-green-600",
                };
            case "warning":
                return {
                    textColor: "text-warning",
                    borderColor: "border-b-2 border-orange-500",
                };
            case "info":
            default:
                return {
                    textColor: "text-info",
                    borderColor: "border-b-2 border-blue-600",
                };
        }
    };
    const headerStyles = getHeaderStyles(currentMessage.type);

    return (
        <Modal
            show={isVisible}
            onHide={hideMessage}
            size="lg"
            className="fade "
            id="cancellation"
            aria-hidden="true"
        >
            <ModalHeader className={headerStyles.borderColor}>
                <h6 className={`modal-title ${headerStyles.textColor}`}>
                    {currentMessage.title}
                </h6>
                <button
                    type="button"
                    onClick={()=>{ 
                        if(currentMessage.title === t("paymentError")){
                            navigate("/");
                        }
                        hideMessage();
                    }}
                    className="btn-close"
                />
            </ModalHeader>
            <ModalBody className="mt-5">
                <h6 className="text-center " style={{fontWeight:"500"}}>
                    {currentMessage.text
                        ? currentMessage.text
                        : t("defaultMessage")}
                </h6>
                {currentMessage.title === t("paymentError") && (
                    <div className="col-md-12 col-sm-12 text-center text-black mt-4">
                        <p>
                             En cas de problème, appelez
                            <img
                                src={satimNum}
                                style={{ width: "50px" ,marginInlineStart:"5px" }}
                                alt="Payment Error"
                            />
                        </p>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};

export default MessageModal;
